import React from "react";
import { Input } from "semantic-ui-react";

interface Props {
  title: string
  onTitleChange: (newTitle: string) => void
}

const DetailsStep = (props: Props) => (
  <table className="s1_table bordergrid gray">
    <tbody>
      <tr>
        <td className="label">{RESX.GeneralLabels.Title}</td>
        <td>
          <Input value={props.title} onChange={(_, { value }) => { props.onTitleChange(value); }} fluid maxLength={serverReference.constants.freeFieldProfile.maxTitleLength} />
        </td>
      </tr>
    </tbody>
  </table >
);

export default DetailsStep;
